// src/app/modules/AccessControl/pages/access-logs-table/column-formatters/PersonColumnFormatter.jsx
// Adaptive formatter for person (visitor/customer/staff/resident)

import React from "react";
import { User, UserCheck, ShieldCheck, Home } from 'lucide-react';

const TYPE_STYLE = {
  staff_shift:      { Icon: ShieldCheck, bg: '#EFF6FF', color: '#2563EB' },
  resident_access:  { Icon: Home,        bg: '#F0EEFF', color: '#5046D6' },
  visitor_entry:    { Icon: UserCheck,   bg: '#F0FDF4', color: '#16a34a' },
};

export function PersonColumnFormatter(cellContent, row, getLabel) {
  const { Icon, bg, color } = TYPE_STYLE[row.log_type] || { Icon: User, bg: '#F0F0F5', color: '#6B6B78' };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{
        width: 34, height: 34, borderRadius: '50%', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: bg, color,
      }}>
        <Icon size={16} />
      </div>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>{row.visitor_name || 'Unknown'}</div>
        {row.visitor_phone && <div className="sety-tbl-sub">{row.visitor_phone}</div>}
        {row.visitor_company && <div className="sety-tbl-sub">{row.visitor_company}</div>}
        {row.log_type === 'staff_shift' && row.employee_id && (
          <div className="sety-tbl-sub">ID: {row.employee_id}</div>
        )}
        {row.log_type === 'resident_access' && row.unit_number && (
          <div className="sety-tbl-sub">Unit {row.unit_number}</div>
        )}
      </div>
    </div>
  );
}
